module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/icon.css?family=Material+Icons
// module id = ./src/assets/css/icon.css?family=Material+Icons
// module chunks = styles